import configuration from "./configuration";

const rootStore = {
  configuration
};

export default rootStore;
